"use client";

import * as React from "react";
import { ThemeProvider as NextThemesProvider } from "next-themes";
import { type ThemeProviderProps } from "next-themes/dist/types";

export function ThemeProvider({ children, ...props }: ThemeProviderProps) {
  const [isMounted, setIsMounted] = React.useState(false);

  React.useEffect(() => {
    if (!isMounted) {
      setIsMounted(true);
    }
  }, []);

  if (isMounted) return <NextThemesProvider {...props}>{children}</NextThemesProvider>;
}
